import { render, staticRenderFns } from "./TaskButtons.vue?vue&type=template&id=bab0acac&scoped=true&"
import script from "./TaskButtons.vue?vue&type=script&lang=js&"
export * from "./TaskButtons.vue?vue&type=script&lang=js&"
import style0 from "./TaskButtons.vue?vue&type=style&index=0&id=bab0acac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab0acac",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QIcon,QDialog} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QIcon,QDialog}, component.options.components || {})
